import { useState, useEffect, useCallback } from 'react';

const CIRCUMFERENCE = 2 * Math.PI * 24;

export default function ScrollButtons() {
  const [showTop, setShowTop] = useState(false);
  const [showBottom, setShowBottom] = useState(true);
  const [scrollProgress, setScrollProgress] = useState(0);

  const handleScroll = useCallback(() => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const atBottom = scrollY + windowHeight >= documentHeight - 10;
    const scrollableDistance = documentHeight - windowHeight;

    setShowTop(scrollY > 300);
    setShowBottom(!atBottom);
    setScrollProgress(scrollableDistance > 0 ? scrollY / scrollableDistance : 0);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  };

  return (
    <>
      {/* Scroll to Bottom */}
      <button
        onClick={scrollToBottom}
        aria-label="Scroll to bottom"
        className={`fixed right-6 bottom-[148px] md:bottom-[156px] z-40 w-12 h-12 rounded-full bg-accent-500 text-white flex items-center justify-center shadow-lg shadow-accent-500/25 hover:scale-110 hover:bg-accent-400 transition-all duration-300 cursor-pointer ${showBottom ? 'opacity-90 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-2 pointer-events-none'}`}
      >
        <i className="ri-arrow-down-line text-xl"></i>
      </button>

      {/* Scroll to Top with progress ring */}
      <button
        onClick={scrollToTop}
        aria-label="Scroll to top"
        className={`fixed right-6 bottom-[92px] md:bottom-[100px] z-40 w-14 h-14 flex items-center justify-center cursor-pointer group transition-all duration-300 ${showTop ? 'opacity-90 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-2 pointer-events-none'}`}
      >
        {/* Progress ring SVG */}
        <svg
          className="absolute inset-0 w-full h-full -rotate-90"
          viewBox="0 0 56 56"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Track ring */}
          <circle
            cx="28"
            cy="28"
            r="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            className="text-foreground-200"
          />
          {/* Progress ring */}
          <circle
            cx="28"
            cy="28"
            r="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            className="text-primary-500 transition-[stroke-dashoffset] duration-150 ease-out"
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={CIRCUMFERENCE * (1 - Math.min(scrollProgress, 1))}
          />
        </svg>
        {/* Button */}
        <span className="relative z-10 w-11 h-11 rounded-full bg-primary-500 text-white flex items-center justify-center shadow-lg shadow-primary-500/25 group-hover:scale-110 group-hover:bg-primary-400 transition-all duration-300">
          <i className="ri-arrow-up-line text-xl"></i>
        </span>
      </button>
    </>
  );
}